import { useEffect, useState } from "react";

/**
 * A clock that re-renders on an interval.
 *
 * Presence in this dock is "has beaten within 10s", which decays with time rather
 * than with incoming messages — without a ticker a headset that stops sending would
 * stay green forever. Returning the timestamp rather than a counter keeps the value
 * honest: every consumer actually uses it, so it never has to be smuggled into a
 * dependency array as an unused dep.
 */
export function useNow(intervalMs = 1000): number {
  const [now, setNow] = useState(() => Date.now());

  useEffect(() => {
    const id = window.setInterval(() => setNow(Date.now()), intervalMs);
    return () => window.clearInterval(id);
  }, [intervalMs]);

  return now;
}
